import Box from '@zenbusiness/zui/Box';

import CopyButton from '#client/components/CopyButton';
import useCardsContext from '#client/hooks/useCardsContext';

import Field from './components/Field';
import TextField from './components/TextField';

import useCardInfo from './hooks/useCardInfo';
import useTrackCardEvents from './hooks/useTrackCardEvents';
import useVGSShow from './hooks/useVGSShow';

export default function DetailCardFields() {
  const { clickCopyTracker } = useTrackCardEvents();

  const { virtualCard, loadingCard } = useCardsContext();
  const { cardholder, expiry, postalCode } = useCardInfo();
  const { loadingCCV, loadingCardNumber, refCCV, refCardNumber } = useVGSShow();

  const CCVCopyButton = (
    <CopyButton
      arrow
      placement="top"
      ref={refCCV}
    >
      <Box
        id="cvv2Copy"
        maxHeight={30}
        maxWidth={{ xs: 40 }}
      />
    </CopyButton>
  );

  const CardNumberCopyButton = (
    <CopyButton
      arrow
      placement="top"
      ref={refCardNumber}
    >
      <Box
        id="cardNumberCopy"
        maxHeight={30}
        maxWidth={{ xs: 40 }}
      />
    </CopyButton>
  );

  if (!virtualCard) {
    return null;
  }

  return [
    <TextField
      clickCopyTracker={clickCopyTracker}
      key="Cardholder"
      loading={loadingCard}
      title="Cardholder"
      value={cardholder}
    />,
    <Field
      copyButton={CardNumberCopyButton}
      key="Card Number"
      loading={loadingCardNumber}
      title="Card Number"
      valueNode={
        <Box
          id="cardNumber"
          maxHeight={30}
          maxWidth={{ xs: 177, md: 220 }}
          pt={{ xs: '5px', md: '3px' }}
        />
      }
    />,
    <Field
      copyButton={CCVCopyButton}
      key="CVV"
      loading={loadingCCV}
      title="CVV"
      valueNode={
        <Box
          id="cvv2"
          maxHeight={30}
          maxWidth={{ xs: 30, md: 40 }}
          pt={{ xs: '5px', md: '3px' }}
        />
      }
    />,
    <TextField
      clickCopyTracker={clickCopyTracker}
      key="Expiry"
      loading={loadingCard}
      title="Expiry"
      value={expiry}
    />,
    <TextField
      clickCopyTracker={clickCopyTracker}
      key="Zip"
      title="Zip"
      value={postalCode}
    />
  ];
}
